import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "input-line"
};
const _hoisted_2 = {
  class: "input-col"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Имя", -1);

const _hoisted_4 = {
  class: "input-col"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Телефон", -1);

const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Email", -1);

const _hoisted_7 = {
  class: "check-item"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "ch1",
  class: "check-label",
  style: {
    "word-break": "normal"
  }
}, [/*#__PURE__*/_createTextVNode("ознакомлен и согласен с "), /*#__PURE__*/_createElementVNode("a", {
  href: "/agreement",
  target: "_blank"
}, "политикой обработки данных")], -1);

const _hoisted_9 = {
  key: 0,
  style: {
    "color": "red",
    "padding": "10px 0",
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_input_phone_component = _resolveComponent("input-phone-component");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock(_component_el_dialog, {
    "model-value": $props.options.dialog.visible,
    title: "Форма обратной связи",
    onClosed: $options.handlerClosed
  }, {
    footer: _withCtx(() => [_createElementVNode("button", {
      type: "button",
      class: "button",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.handlerSuccess && $options.handlerSuccess(...args))
    }, " Отправить ")]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.name = $event),
      type: "text",
      class: "input",
      placeholder: "Введите имя"
    }, null, 512), [[_vModelText, $data.name]])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_input_phone_component, {
      modelValue: $data.tel,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.tel = $event),
      class: "input"
    }, null, 8, ["modelValue"])])]), _hoisted_6, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.email = $event),
      type: "text",
      class: "input",
      placeholder: "Введите email"
    }, null, 512), [[_vModelText, $data.email]]), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
      id: "ch1",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.agreePolicy = $event),
      type: "checkbox",
      class: "check-input"
    }, null, 512), [[_vModelCheckbox, $data.agreePolicy]]), _hoisted_8]), $data.error ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($data.error), 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["model-value", "onClosed"]);
}